import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function (destination: any) {
    return new Promise<any>((resolve, reject) => {
        axios
            .patch(
                getEndpoint('destinations/{id}', { id: destination.id }),
                destination,
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}